import React, { FC, RefObject, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { updateOptions } from '../../../../../actions';
import { CUSTOM_PRESET_PARAMS } from '../../../../../constants/general';
import { useAnalytics } from '../../../../../hooks/useAnalytics';
import { useOptions } from '../../../../../selectors';
import { SelectInput } from './inputs/SelectInput';
import { Params } from './Params';

const Root = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export interface CustomPresetInputRefs {
  label: RefObject<HTMLInputElement>,
  width: RefObject<HTMLInputElement>,
  height: RefObject<HTMLInputElement>,
}

export const CustomPreset: FC = () => {
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const { selectedPresets, customPreset } = useOptions();

  const inputRefs = {
    label: useRef<HTMLInputElement>(null),
    width: useRef<HTMLInputElement>(null),
    height: useRef<HTMLInputElement>(null),
  };

  const handleSelectChangeRequest = useCallback(() => {
    const emptyParamInputName = CUSTOM_PRESET_PARAMS.find((paramName) => !customPreset.params[paramName]);
    if (emptyParamInputName) {
      inputRefs[emptyParamInputName].current?.focus();
    } else {
      analytics('edit resize and crop', `${!selectedPresets.custom ? 'enable' : 'disable'} Custom preset`);
      dispatch(updateOptions({ selectedPresets: { custom: !selectedPresets.custom } }));
    }
  }, [analytics, inputRefs, dispatch, selectedPresets, customPreset]);

  return (
    <Root>
      <SelectInput onClick={handleSelectChangeRequest} />
      <Params inputRefs={inputRefs} />
    </Root>
  );
};
